<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Stock Opname" active>

                                <b-row v-if="hasFailedDataStockOpname">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedStockOpname.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="stockOpnamesFailed" :fields="fieldsStockOpname" :busy="isDataLoading"
                                                         :sort-by.sync="sortByStockOpname" :sort-desc.sync="sortDescStockOpname" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(totalCaseArea)="row">
													{{ Number(row.item.totalCaseArea).toLocaleString() }}
												</template>
												<template #cell(totalCaseActual)="row">
													{{ Number(row.item.totalCaseActual).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedStockOpname.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="stockOpnames" :fields="fieldsStockOpname" :busy="isDataLoading"
                                                         :sort-by.sync="sortByStockOpname" :sort-desc.sync="sortDescStockOpname" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(totalCaseArea)="row">
													{{ Number(row.item.totalCaseArea).toLocaleString() }}
												</template>
												<template #cell(totalCaseActual)="row">
													{{ Number(row.item.totalCaseActual).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Stock Opname Detail" active>

                                <b-row v-if="hasFailedDataStockOpnameDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedStockOpnameDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="stockOpnameDetailsFailed" :fields="fieldsStockOpnameDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByStockOpnameDetail" :sort-desc.sync="sortDescStockOpnameDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(caseQty)="row">
													{{ Number(row.item.caseQty).toLocaleString() }}
												</template>
												<template #cell(qtyActual)="row">
													{{ Number(row.item.qtyActual).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedStockOpnameDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="stockOpnameDetails" :fields="fieldsStockOpnameDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByStockOpnameDetail" :sort-desc.sync="sortDescStockOpnameDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(caseQty)="row">
													{{ Number(row.item.caseQty).toLocaleString() }}
												</template>
												<template #cell(qtyActual)="row">
													{{ Number(row.item.qtyActual).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import StockOpname from '@/models/StockOpname/StockOpname';
import StockOpnameList from '@/models/StockOpname/StockOpnameList';
import StockOpnameFilter from '@/filters/StockOpname/StockOpnameFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsStockOpname: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Stock Opname Plan", key: 'stockOpnamePlanName', sortable: false},
				{"class" : "th-status", "label" : "Area", key: 'areaStoCode', sortable: false},
				{"class" : "th-status", "label" : "Subcontract Vendor", key: 'vendorSubconCode', sortable: false},
				{"class" : "th-status", "label" : "ID Card", key: 'idCard', sortable: false},
				{"class" : "th-status", "label" : "Total Case", key: 'totalCaseArea', sortable: false},
				{"class" : "th-status", "label" : "Total Case Actual", key: 'totalCaseActual', sortable: false},
				{"class" : "th-status", "label" : "Stock Opname Status", key: 'stockOpnameStatusName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsStockOpnameDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Case Number", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty System", key: 'caseQty', sortable: false},
				{"class" : "th-status", "label" : "Qty Actual", key: 'qtyActual', sortable: false},
				{"class" : "th-status", "label" : "Remarks", key: 'remarks', sortable: false},
				{"class" : "th-status", "label" : "Scanned By", key: 'scannedByFirstName', sortable: false},
				{"class" : "th-status", "label" : "ID Card", key: 'userIdCard', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			stockOpnames : [],
			stockOpnamesFailed: [],
			stockOpnameId : '',
			sortByStockOpname: '',
			sortDescStockOpname: '',
			hasFailedDataStockOpname: false,
			totalFailedStockOpname: 0,
			totalSucceedStockOpname: 0,
			stockOpnameDetails : [],
			stockOpnameDetailsFailed: [],
			stockOpnameDetailId : '',
			sortByStockOpnameDetail: '',
			sortDescStockOpnameDetail: '',
			hasFailedDataStockOpnameDetail: false,
			totalFailedStockOpnameDetail: 0,
			totalSucceedStockOpnameDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('stockopname/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('stockopname/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getStockOpnameForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getStockOpnameForUpload : async function() {
			let _this = this;
			this.$http.get('stockopname/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.stockOpnames = [];
_this.stockOpnameDetails = [];


					if (response != null) {
						let result = response.data;
						_this.stockOpnames = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedStockOpname = _this.stockOpnames.length;

						_this.stockOpnamesFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataStockOpname = true;
						_this.totalFailedStockOpname = 0;
						if(_this.stockOpnamesFailed == undefined || _this.stockOpnamesFailed.length === 0) _this.hasFailedDataStockOpname = false;
						if(_this.hasFailedDataStockOpname) _this.totalFailedStockOpname = _this.stockOpnamesFailed.length;
						_this.stockOpnameDetails = [];
						_this.stockOpnameDetailsFailed = [];
						_this.hasFailedDataStockOpnameDetail = true;
						_this.totalSucceedStockOpnameDetail = 0;
						result.forEach(function(element) {
							_this.stockOpnameDetails.push(...element.stockOpnameDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedStockOpnameDetail = _this.stockOpnameDetails.length;

							_this.stockOpnameDetailsFailed.push(...element.stockOpnameDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.stockOpnameDetailsFailed == undefined || _this.stockOpnameDetailsFailed.length === 0) _this.hasFailedDataStockOpnameDetail = false;
							if(_this.hasFailedDataStockOpnameDetail) _this.totalFailedStockOpnameDetail = _this.stockOpnameDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'stockopname/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'StockOpname.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterStockOpname = new StockOpnameFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
